export interface Label {
  key: string;
  params?: any;
}

export enum Orientation {
  horizontal = 'horizontal',
  vertical = 'vertical'
}

export enum HorizontalAlignment {
  left = 'left',
  right = 'right'
}

export enum VerticalAlignment {
  top = 'top',
  bottom = 'bottom'
}

export enum Position {
  top = 'top',
  bottom = 'bottom',
  left = 'left',
  right = 'right'
}
